const imagesLoaded = require('imagesloaded');
import Cursor from './js/app/components/cursor';
import Lottie from 'lottie-web';
import jquery from 'jquery';
import * as THREE from 'three'
import * as dat from 'dat.gui'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import owd from './js/owd/owd';
import './js/app/components/hover-path';
import VirtualScroll from 'virtual-scroll'
import { lscroll } from './js/app/components/smoothScroll'
import barba from '@barba/core'
import { gsap } from 'gsap'
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";
import Player from '@vimeo/player';
import 'scroll-restoration-polyfill';
import screenfull from 'screenfull'
import Stats from 'stats.js'
import hexRgb from 'hex-rgb'
import WebFont from 'webfontloader'
import baseVertex from './base.vert'
import textFragment from './text.frag'
import persistenceFragment from './persistence.frag'

window.$ = jquery;
window.jQuery = jquery;


const cmsLink = (window.location.href.includes("mc-staging2") ? "https://privateisland-cms.mc-staging2.net" : "https://cms.privateisland.tv")



// Custom cursor
let cursor = new Cursor(document.querySelector('.cursor'));
let cursor2 = new Cursor(document.querySelector('.cursor2'));
let _cursorAnimation = Lottie.loadAnimation({
    container: document.getElementById('cursor'), // required
    path: 'models/cursor.json', // required
    renderer: 'svg', // required
    loop: true, // optional
    autoplay: false, // optional
    name: "Demo Animation", // optional
});
_cursorAnimation.play();
_cursorAnimation.playSpeed = 1.10;
let _winkerAnimation = Lottie.loadAnimation({
    container: document.getElementById('winker'), // required
    path: 'models/winker.json', // required
    renderer: 'svg', // required
    loop: true, // optional
    autoplay: true, // optional
    name: "Winker Animation", // optional
});


if ($('.notFound').length > 0) {
    $('.cursor').hide()
    $('.cursor2').addClass('show')
}


// title change functio
const titleHanlder = () => {
    var message = "No YOU'RE a sellout";
    var original;

    $(window).focus(function () {
        if (original) {
            document.title = original;
        }
    }).blur(function () {
        var title = $('title').text();
        if (title != message) {
            original = title;
        }
        document.title = message;
    });
};

const navLinkHover = () => {
    const navLinks = document.querySelectorAll('.p_link')

    navLinks.forEach(item => {
        item.addEventListener('click', function () {
            if ($('.p_link').hasClass('active')) {
                $('.p_link').removeClass('active')
            }
            item.classList.add('active')
        })
    });
}
navLinkHover()


// Home page data
const homeContent = () => {
    if ($('.pageContent__projects').length > 0) {
        $('body').addClass('hc_loaded')
        fetch(cmsLink + '/wp-json/wp/v2/pages/68')
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                const projectTitles = data.ACF.post_object
                const titles = document.querySelectorAll('.projectTitle')
                const workUrl = document.querySelectorAll('.w__link')
                const hoverImg = document.querySelectorAll('.draw__img')
                const workId = document.querySelectorAll('[data-index]')
                projectTitles.forEach((title, index) => {
                    workId[index].dataset.index = title.ID
                    titles[index].innerHTML = title.post_title
                    var singleWorkUrl = 'project#' + title.slug
                    fetch(cmsLink + '/wp-json/wp/v2/work/' + title.ID)
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (data) {
                            singleWorkUrl = data.slug;
                            workUrl[index].href = 'project#' + data.slug
                            hoverImg[index].src = data.ACF.animated_hover_image
                            // _mobileAnimation1.assetsPath = data.ACF.animated_hover_image;
                        });

                    setTimeout(function () {
                        lscroll.update()
                    }, 500);
                });
            })
            .then(function () {
                // lscroll.start()
                setTimeout(() => {
                    if ($('.introWrapper').length && !$('body').hasClass('hm-loaded')) {
                        if (window.innerWidth > 995) {
                            lscroll.scrollTo('right', {
                                'offset': 0,
                                'duration': 50,
                                'easing': [0.25, 0.20, 0.25, .20],
                                'disableLerp': false
                            });
                        }
                    }
                }, 500);
                setTimeout(function () {
                    let element = document.querySelector('.introWrapper')
                    if ($('.introWrapper').length > 0) {
                        setTimeout(function () {
                            element.style.opacity = "1"

                        }, 200);
                    }
                    // Intro animation
                    if ($('.introWrapper').length && !$('body').hasClass('hm-loaded')) {
                        let tl = gsap.timeline()
                        function tlComplete(){
                            _cursorAnimation.pause();
                            document.getElementsByClassName("intro_us_lisk")[0].style.pointerEvents = "all"
                        }

                        if (window.innerWidth > 995) {
                            tl.to('.c-scrollbar_thumb', { duration: .3, delay: 0, opacity: 0, ease: 'Expo.easeInOut' })
                            tl.to('.introWrapper__mask', { x: '101%', duration: 6.4, delay: -3, ease: 'Expo.easeInOut' })
                            tl.from(element, { duration: 1, delay: 0, x: 0, y: (window.innerHeight / 2), z: -2018.38, ease: 'Expo.easeInOut' })
                            tl.to(element, { duration: 2, delay: .5, x: 0, y: 0, z: 0, opacity: 1, ease: 'Expo.easeInOut' })
                            tl.to('.c-scrollbar_thumb', { duration: 1, delay: 0, opacity: 1, ease: 'Expo.easeInOut' })
                            tl.play()
                        } else {
                            tl.to('.introWrapper__mask', { duration: 1.4, delay: 1.5, y: '-110%', ease: 'Expo.easeInOut' })
                            tl.from('.pageContent__projects', { duration: 1, delay: -.8, x: 0, y: 288, ease: 'Expo.easeInOut' },)
                            tl.to('.pageContent__projects', { duration: 1, delay: 0, x: 0, y: 0, ease: 'Expo.easeInOut' })
                            tl.play()
                        }

                        //With timing functions the timeline only fires a complete event a few seconds after visually finishing
                        tl.add(tlComplete, ">-3")

                        setTimeout(function () {
                            if (window.innerWidth > 995) {
                                lscroll.scrollTo('left', {
                                    'offset': 0,
                                    'duration': 3000,
                                    'easing': [0.55, 0.30, 0.35, 1.00],
                                    'disableLerp': false
                                });
                            }
                        }, 1500);
                    }
                    $('body').addClass('hm-loaded')
                }, 1000);
            })

    }
}
homeContent()

// Preload head animation
const _preloadAnim = Lottie.loadAnimation({
    container: document.querySelector('.preloadAnim'), // required
    path: 'models/cursor.json', // required
    renderer: 'svg', // required
    loop: true, // optional
    autoplay: true, // optional
    name: "Demo Animation", // optional
});
_preloadAnim.playSpeed = 1.10;
const _preloadAnim2 = Lottie.loadAnimation({
    container: document.querySelector('.preloadAnim2'), // required
    path: 'models/winker.json', // required
    renderer: 'svg', // required
    loop: true, // optional
    autoplay: true, // optional
    name: "Demo Animation", // optional
});



// Page loader
if ($('.introWrapper').length < 1) {
    $('body').addClass('dark')
}


// Work page data
const workContent = () => {
    fetch(cmsLink + '/wp-json/wp/v2/work/?per_page=100')
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            const works = data
            let workWrapper = document.querySelector('.work__list')
            let workInner = document.querySelector('.work__list--item')
            for (let i = 0; i < works.length - 1; i++) {
                let workInnerClone = workInner.cloneNode(true);
                workWrapper.appendChild(workInnerClone)
            }
            const worktitle = document.querySelectorAll('.vTitle')
            const mobilePoster = document.querySelectorAll('.mobilePoster')
            const workUrl = document.querySelectorAll('.workBtn')
            const _clientName = document.querySelectorAll('[data-title]')
            const workId = document.querySelectorAll('[data-index]')
            works.forEach((item, index) => {
                let singleWorkUrl = 'project#' + item.slug

                workUrl[index].href = singleWorkUrl
                worktitle[index].innerHTML = item.title.rendered
                _clientName[index].dataset.title = item.ACF.client_name
                workId[index].dataset.index = item.id
                _clientName[index].dataset.agencyTitle = item.ACF.agency_name
                mobilePoster[index].src = item.ACF.video_poster_image.url
            });
            fetch(cmsLink + '/wp-json/wp/v2/pages/265')
                .then(function (response) {
                    return response.json();
                })
                .then(function (data) {
                    const worksTexts = data
                    const text1 = worksTexts.ACF.top_text
                    const text2 = worksTexts.ACF.bottom_text
                    const topText = document.querySelector('.topText')
                    const bottomText = document.querySelector('.bottomText')
                    topText.innerHTML = text1
                    bottomText.innerHTML = text2
                    lscroll.update()
                    setTimeout(() => {
                        const text1anim = Splitting({ target: topText, by: 'chars' });
                        const text2anim = Splitting({ target: bottomText, by: 'chars' });
                        let scroll = { cache: 0, current: 0 };
                        const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;
                        const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;
                        const textChar = [...document.querySelectorAll('.skewMore .char')]
                        lscroll.on('scroll', (args) => {
                            scroll.current = args.scroll.x;
                            const distance = scroll.current - scroll.cache;
                            scroll.cache = scroll.current;
                            const tsval = map(distance, -55, 55, -55, 55);
                            textChar.forEach(el => el.style.transform = 'skewY(' + clamp(tsval, -20, 20) + 'deg)');
                        })
                    }, 700);

                })
            setTimeout(() => {
                const workItem = document.querySelectorAll('.work__list--item')
                const workHoverLine = document.querySelectorAll('.hover__line')

                workItem.forEach((item, index) => {
                    item.addEventListener('mouseenter', function () {
                        workHoverLine[index].classList.add('active')
                    })
                    item.addEventListener('mouseleave', function () {
                        workHoverLine[index].classList.remove('active')
                    })
                });

                setTimeout(() => {
                    _cursorAnimation.pause();
                    videoHandler();
                }, 1500);
                [...document.querySelectorAll('a , button')].forEach(link => {
                    link.addEventListener('click', () => cursor.active());
                    link.addEventListener('mouseenter', () => cursor.enter());
                    link.addEventListener('mouseleave', () => cursor.leave());
                });
            }, 700);

        })
}

if (window.innerWidth > 1030) {
    let scrBar = document.getElementsByClassName("c-scrollbar_thumb")[0]
    if(scrBar){
        scrBar.addEventListener('click', () => cursor.active());
        scrBar.addEventListener('mouseenter', () => cursor.enter());
        scrBar.addEventListener('mouseleave', () => cursor.leave());
    }
}

// Single work page data
const workSingleContent = () => {

    const work_slug = window.location.hash.slice(1)

    fetch(cmsLink + '/wp-json/wp/v2/work/?slug=' + work_slug)
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            const workSingleData = data[0]
            const clineName = document.querySelector('.clientInfo__name')
            const agencyName = document.querySelector('.agencyInfo__name')
            const workTitle = document.querySelector('.work__title')
            const workBio = document.querySelector('.workBio__text')
            const navClinet = document.querySelectorAll('.client__name')
            const navAgency = document.querySelectorAll('.agency__name')
            const videoUrl = document.querySelector('#iFrame')
            const videoLink = workSingleData.ACF.vimeo_url

            videoUrl.src = "https://player.vimeo.com/video/" + videoLink + "?color=ffffff&amp;title=0&amp;byline=0&amp;portrait=0&amp;controls=0&amp;playsinline=1;"
            clineName.innerHTML = workSingleData.ACF.client_name
            agencyName.innerHTML = workSingleData.ACF.agency_name
            workBio.innerHTML = workSingleData.content.rendered
            workTitle.innerHTML = workSingleData.title.rendered
            const altInfo = document.querySelectorAll('.altInfo')
            const altVideoWrapper = document.querySelector('.workDetails__altBanner')
            const altvideo1Url = document.querySelector('.alt1_video')
            const altvideo1Name = document.querySelector('.altName1')
            const altvideo2Url = document.querySelector('.alt2_video')
            const altvideo2Name = document.querySelector('.altName2')
            if (workSingleData.ACF.more_videos) {
                const altViode1 = workSingleData.ACF.additional_vimeo_urls[0].vimeo_alt
                const alt1Name = workSingleData.ACF.additional_vimeo_urls[0].vimeo
                altvideo1Url.src = "https://player.vimeo.com/video/" + altViode1 + "?color=ffffff&amp;title=0&amp;byline=0&amp;portrait=0&amp;controls=0&amp;playsinline=1;"
                altvideo1Name.innerHTML = alt1Name

                if (workSingleData.ACF.additional_vimeo_urls[1]) {
                    let altViode2 = workSingleData.ACF.additional_vimeo_urls[1].vimeo_alt
                    const alt2Name = workSingleData.ACF.additional_vimeo_urls[1].vimeo
                    altvideo2Url.src = "https://player.vimeo.com/video/" + altViode2 + "?color=ffffff&amp;title=0&amp;byline=0&amp;portrait=0&amp;controls=0&amp;playsinline=1;"
                    altvideo2Name.innerHTML = alt2Name
                    document.getElementsByClassName("altInfo")[0].children[0].innerText = "Right top"
                } else {
                    document.getElementById("altVideo2").style.display = "none"
                    document.getElementsByClassName("altInfo")[1].style.display = "none"
                    document.getElementsByClassName("altInfo")[0].children[0].innerText = "Right"
                }

                if(window.innerWidth <= 1030){
                    document.getElementsByClassName("altInfo")[0].children[0].innerText = "below"
                    document.getElementsByClassName("altInfo")[1].children[0].innerText = "below"
                }

                altInfo.forEach(item => {
                    item.classList.add('show')
                });
                altVideoWrapper.classList.add('showAlt')
            }
            // var workInfo_bottom = document.getElementById('workInfo_bottom').offsetHeight;
            // if (workInfo_bottom > 350 && window.innerHeight < 900 && window.innerWidth > 1030) {
            //     $('.workDetails__workInfo--bottom').addClass('split_more')
            //     lscroll.update()
            // }
            var workInfo = document.getElementsByClassName("workDetails__workInfo")[0]
            if(workInfo && (window.innerWidth > 1030)){
                if(workInfo.offsetHeight > (window.innerHeight - 200)){
                    workInfo.classList += " break--1 "
                    
                    if(workInfo.offsetHeight > (window.innerHeight - 100)){
                        workInfo.classList += " break--2 "
                    }
                }
                
                lscroll.update()
            }
            $('#workDetails--more').click(function() {
                lscroll.scrollTo('right', {
                    'offset': 0,
                    'duration': 300,
                    'easing': [0.25, 0.20, 0.25, .20],
                    'disableLerp': false
                });
                $('#workDetails--more').removeClass('show')
            })
            lscroll.update()
            VideoLoadAnimation()
            setTimeout(() => {
                _cursorAnimation.pause();
                [...document.querySelectorAll('a , button')].forEach(link => {
                    link.addEventListener('click', () => cursor.active());
                    link.addEventListener('mouseenter', () => cursor.enter());
                    link.addEventListener('mouseleave', () => cursor.leave());
                });

                lscroll.on('scroll', (args) => {
                    if (typeof args.currentElements['work_info'] === 'object') {
                        let progress = args.currentElements['work_info'].progress;
                        if (progress > .08 && lscroll.scroll.instance.delta.x > .08) {
                            $('.reval').addClass('show')
                            $('#workDetails--more').removeClass('show')
                        } else {
                            $('.reval').removeClass('show')
                            $('#workDetails--more').addClass('show')
                        }
                    }
                    if (typeof args.currentElements['work_mVideo'] === 'object' && $('.workDetails__altBanner').length > 0) {
                        let progress = args.currentElements['work_mVideo'].progress;
                        if (progress > .06) {
                            $('.singleBanner').addClass('show')
                        } else {
                            $('.singleBanner').removeClass('show')
                        }
                    }
                })
            }, 1000);
        })

}

const singleWorkNav = () => {
    if ($('.workDetails').length > 0) {
        const work_slug = window.location.hash.slice(1)
        fetch(cmsLink + '/wp-json/wp/v2/work/?slug=' + work_slug)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                const workSingleData = data[0]
                const oldNav = document.querySelectorAll('.fixed__menuLink .char')
                const newNav = document.querySelectorAll('.new__menuLink .char')
                const navIndex = document.querySelectorAll('[data-id]')
                const navAgencyIndex = document.querySelectorAll('[data-agency-id]')
                const navHeaderIndex = document.querySelectorAll('[data-header-id]')
                const navFooterIndex = document.querySelectorAll('[data-footer-id]')

                oldNav.forEach(oitem => {
                    gsap.to(oitem, {
                        duration: 1,
                        x: 35,
                        skewY: 30,
                        opacity: 0,
                        ease: "Expo.easeOut",
                    });
                });

                newNav.forEach(nitem => {
                    gsap.fromTo(nitem, {
                        x: -30,
                        skewY: -30,
                        opacity: 0,
                    }, {
                        x: 0,
                        skewY: 0,
                        opacity: 1,
                        duration: 1.5,
                        ease: "Expo.easeOut",
                    });
                });

                navIndex.forEach((nitem, index) => {
                    nitem.classList.add('hide')
                    if (workSingleData.id == navIndex[index].dataset.id) {
                        navIndex[index].classList.remove('hide')
                    }
                });
                navAgencyIndex.forEach((nitem, index) => {
                    nitem.classList.add('hide')
                    if (workSingleData.id == navAgencyIndex[index].dataset.agencyId) {
                        navAgencyIndex[index].classList.remove('hide')
                    }
                });
                navHeaderIndex.forEach((nitem, index) => {
                    nitem.classList.add('hide')
                    if (workSingleData.id == navHeaderIndex[index].dataset.headerId) {
                        navHeaderIndex[index].classList.remove('hide')
                    }
                });
                navFooterIndex.forEach((nitem, index) => {
                    nitem.classList.add('hide')
                    if (workSingleData.id == navFooterIndex[index].dataset.footerId) {
                        navFooterIndex[index].classList.remove('hide')
                    }
                });
            })

    }
}


// Contact form 
$.fn.extend({ backspace: function (e, t) { var n; return n = $.extend({ callback: function () { }, keypress: function () { }, t: 100, e: .04 }, t), this.each(function () { var t; t = this, $(t).queue(function () { var i, a; a = function (e, i) { e ? (t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"] = t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"].slice(0, -1), n.keypress.call(t), setTimeout(function () { a(e - 1, i) }, n.t)) : (n.callback.call(t), $(t).dequeue()) }, i = function (e, a) { e ? (t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"] += e[0], n.keypress.call(t), setTimeout(function () { i(e.slice(1), a) }, n.t)) : a() }, a(e) }) }) }, typetype: function (e, t) { var n; return n = $.extend({ callback: function () { }, keypress: function () { }, t: 100, e: .04 }, t), this.each(function () { var t; t = this, $(t).queue(function () { var i, a, c; a = function (e, i) { e ? (t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"] = t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"].slice(0, -1), n.keypress.call(t), setTimeout(function () { a(e - 1, i) }, n.t)) : i() }, i = function (e, a) { e ? (t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"] += e[0], n.keypress.call(t), setTimeout(function () { i(e.slice(1), a) }, n.t)) : a() }, (c = function (u) { var s, l; s = function () { return setTimeout(function () { c(u) }, Math.random() * n.t * (e[u - 1] === e[u] ? 1.6 : "." === e[u - 1] ? 12 : "!" === e[u - 1] ? 12 : "?" === e[u - 1] ? 12 : "\n" === e[u - 1] ? 12 : "," === e[u - 1] ? 8 : ";" === e[u - 1] ? 8 : ":" === e[u - 1] ? 8 : " " === e[u - 1] ? 3 : 2)) }, l = Math.random() / n.e, e.length >= u ? .3 > l && e[u - 1] !== e[u] && e.length > u + 4 ? i(e.slice(u, u + 4), function () { a(4, s) }) : .7 > l && u > 1 && /[A-Z]/.test(e[u - 2] && e.length > u + 4) ? i(e[u - 1].toUpperCase() + e.slice(u, u + 4), function () { a(5, s) }) : .5 > l && e[u - 1] !== e[u] && e.length > u ? i(e[u], function () { a(1, s) }) : 1 > l && e[u - 1] !== e[u] && e.length > u ? i(e[u] + e[u - 1], function () { a(2, s) }) : .5 > l && /[A-Z]/.test(e[u]) ? i(e[u].toLowerCase(), function () { a(1, s) }) : (t[/(np|x)/i.test(t.tagName) ? "value" : "innerHTML"] += e[u - 1], n.keypress.call(t), setTimeout(function () { c(u + 1) }, Math.random() * n.t * (e[u - 1] === e[u] ? 1.6 : "." === e[u - 1] ? 12 : "!" === e[u - 1] ? 12 : "?" === e[u - 1] ? 12 : "\n" === e[u - 1] ? 12 : "," === e[u - 1] ? 8 : ";" === e[u - 1] ? 8 : ":" === e[u - 1] ? 8 : " " === e[u - 1] ? 3 : 2))) : (n.callback.call(t), $(t).dequeue()) })(1) }) }) } });
// Us page data
const aboutContent = () => {
    fetch(cmsLink + '/wp-json/wp/v2/pages/23')
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            console.log(data);
            const aboutPi = document.querySelector('.aboutPi')
            const toptext = document.querySelector('.topText--text')
            const formIntro = document.querySelector('.form__intro')
            // const contactText = document.querySelector('.contact__text')
            const usVideo = document.querySelector('.usVideo')
            const startText = document.querySelector('.start_text')
            const messageIntro = data.ACF.contact_title
            aboutPi.innerHTML = data.ACF.text_block_1
            toptext.innerHTML = data.ACF.text_block_3
            formIntro.innerHTML = data.ACF.small_text
            // contactText.innerHTML = data.ACF.contact
            startText.innerText = data.ACF.start_of_sentence
            usVideo.src = data.ACF.video
            usVideo.muted = true
            usVideo.play()


            // Offices

            const officeName = document.querySelectorAll('.officeName')
            const officeAddress = document.querySelectorAll('.officeAddress')
            const officeNumber = document.querySelectorAll('.officeNumber')
            const officeEmail = document.querySelectorAll('.officeEmail')

            const offices = data.ACF.offices
            offices.forEach((item, index) => {
                officeName[index].innerHTML = item.heading
                officeAddress[index].innerHTML = item.address
                officeNumber[index].innerHTML = item.phone_number
                officeEmail[index].innerHTML = item.email
            });

            officeEmail.forEach(item => {
                item.addEventListener('click', function () {
                    event.preventDefault()
                    var email = item.innerHTML;
                    var subject = "Hello Private Island";
                    document.location = "mailto:" + email + "?subject=" + subject;
                })
            });

            lscroll.update()
            setTimeout(() => {
                _cursorAnimation.pause();
                $('#user_message').typetype(messageIntro)
            }, 1500);
        })
}

// Preload images
const preloadImages = (selector = 'img') => {
    return new Promise((resolve) => {
        imagesLoaded(document.querySelectorAll(selector), { background: true }, resolve);
    });
};



// MObile loader json animation
const __mobileLoaderAnimation = Lottie.loadAnimation({
    container: document.getElementById('mobile_loader'), // required
    path: 'models/cursor.json', // required
    renderer: 'svg', // required
    loop: true, // optional
    autoplay: true, // optional
    name: "mobile loader animation", // optional
});





const scroller = new VirtualScroll()
scroller.on(event => {
    var mTimer;
    clearTimeout(mTimer);
    mTimer = setTimeout(function () {
        if (_cursorAnimation !== undefined) {
            _cursorAnimation.pause();
        }
    }, 300);
    if (event.deltaY <= -1) {
        if (_cursorAnimation !== undefined) {
            _cursorAnimation.setDirection(1);
            _cursorAnimation.playSpeed = 1.10;
            _cursorAnimation.play();
        }
    } else {
        if (_cursorAnimation !== undefined) {
            _cursorAnimation.setDirection(-1);
            _cursorAnimation.playSpeed = 1.10;
            _cursorAnimation.play();
        }
    }



})
if (document.querySelector('.cursor',)) {
    [...document.querySelectorAll('a , button')].forEach(link => {
        link.addEventListener('mouseenter', () => cursor.enter());
        link.addEventListener('mouseleave', () => cursor.leave());
    });
}
if (document.querySelector('.cursor2',)) {
    [...document.querySelectorAll('a , button')].forEach(link => {
        link.addEventListener('mouseenter', () => cursor2.enter());
        link.addEventListener('mouseleave', () => cursor2.leave());
    });
}





// Preload images and fonts
const contentLoadHandler = () => {
    Promise.all([preloadImages('._img')]).then(() => {
        _infiniteProject()
    });
}
contentLoadHandler()


// Split logo letter
Splitting()




// Text & Json animation on scroll
const _infiniteProject = () => {
    // Getting all mobile json animation
    const _mobileAnimation1 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim1'),
        path: 'models/mobile_anim1.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    if ($('.introWrapper').length && !$('body').hasClass('hm-loaded')) {
        setTimeout(function () {
            _mobileAnimation1.play();
        }, 5500);
        setTimeout(function () {
            _mobileAnimation1.pause();
        }, 6500);
    }

    const _mobileAnimation2 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim2'),
        path: 'models/mobile_anim2.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    const _mobileAnimation3 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim3'),
        path: 'models/mobile_anim3.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    const _mobileAnimation4 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim4'),
        path: 'models/mobile_anim4.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        assetsPath: cmsLink + "/wp-content/uploads/"
    });
    const _mobileAnimation5 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim5'),
        path: 'models/mobile_anim5.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    const _mobileAnimation6 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim6'),
        path: 'models/mobile_anim6.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });
    const _mobileAnimation7 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim7'),
        path: 'models/mobile_anim7.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    const _mobileAnimation8 = Lottie.loadAnimation({
        container: document.getElementById('mobileAnim8'),
        path: 'models/mobile_anim8.json',
        renderer: 'svg',
        loop: false,
        autoplay: false,
        name: "Demo Animation",
        assetsPath: cmsLink + "/wp-content/uploads/"
    });

    let scroll = { cache: 0, current: 0 };
    const map = (x, a, b, c, d) => (x - a) * (d - c) / (b - a) + c;
    const clamp = (num, min, max) => num <= min ? min : num >= max ? max : num;
    const logoChar = [...document.querySelectorAll('.char')]
    // const allImgs = [...document.querySelectorAll('.skewImg')];
    const allTitle = [...document.querySelectorAll('.project')];
    lscroll.on('scroll', (args) => {
        scroll.current = args.scroll.x;
        const distance = scroll.current - scroll.cache;
        scroll.cache = scroll.current;
        const skewVal = map(distance, -50, 50, -15, 15);
        const skewVal2 = map(distance, -150, 150, -115, 115);
        const tsval = map(distance, -55, 55, -55, 55);
        logoChar.forEach(el => el.style.transform = 'skewY(' + clamp(tsval, -20, 20) + 'deg)');
        // textChar.forEach(el => el.style.transform = 'skewY(' + clamp(tsval, -20, 20) + 'deg)');
        // allImgs.forEach(el => el.style.transform = 'skewX(' + clamp(skewVal, -15, 15) + 'deg)');
        allTitle.forEach(el => el.style.transform = 'skewX(' + clamp(skewVal2, -25, 25) + 'deg)');



        if (typeof args.currentElements['project1'] === 'object') {
            let progress = args.currentElements['project1'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation1 !== undefined) {
                    _mobileAnimation1.pause();
                }
            }, 500);
            if (_mobileAnimation1 !== undefined && args.direction == "down") {
                _mobileAnimation1.setDirection(1);
                _mobileAnimation1.play();
            }
            else {
                if (_mobileAnimation1 !== undefined) {
                    _mobileAnimation1.setDirection(-1);
                    _mobileAnimation1.play();
                }
            }
        }
        if (typeof args.currentElements['project2'] === 'object') {
            let progress = args.currentElements['project2'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation2 !== undefined) {
                    _mobileAnimation2.pause();
                }
            }, 500);
            if (_mobileAnimation2 !== undefined && args.direction == "down") {
                _mobileAnimation2.setDirection(1);
                _mobileAnimation2.play();
            }
            else {
                if (_mobileAnimation2 !== undefined) {
                    _mobileAnimation2.setDirection(-1);
                    _mobileAnimation2.play();
                }
            }
        }
        if (typeof args.currentElements['project3'] === 'object') {
            let progress = args.currentElements['project3'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation3 !== undefined) {
                    _mobileAnimation3.pause();
                }
            }, 500);
            if (_mobileAnimation3 !== undefined && args.direction == "down") {
                _mobileAnimation3.setDirection(1);
                _mobileAnimation3.play();
            }
            else {
                if (_mobileAnimation3 !== undefined) {
                    _mobileAnimation3.setDirection(-1);
                    _mobileAnimation3.play();
                }
            }
        }
        if (typeof args.currentElements['project4'] === 'object') {
            let progress = args.currentElements['project4'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation4 !== undefined) {
                    _mobileAnimation4.pause();
                }
            }, 500);
            if (_mobileAnimation4 !== undefined && args.direction == "down") {
                _mobileAnimation4.setDirection(1);
                _mobileAnimation4.play();
            }
            else {
                if (_mobileAnimation4 !== undefined) {
                    _mobileAnimation4.setDirection(-1);
                    _mobileAnimation4.play();
                }
            }
        }
        if (typeof args.currentElements['project5'] === 'object') {
            let progress = args.currentElements['project5'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation5 !== undefined) {
                    _mobileAnimation5.pause();
                }
            }, 500);
            if (_mobileAnimation5 !== undefined && args.direction == "down") {
                _mobileAnimation5.setDirection(1);
                _mobileAnimation5.play();
            }
            else {
                if (_mobileAnimation5 !== undefined) {
                    _mobileAnimation5.setDirection(-1);
                    _mobileAnimation5.play();
                }
            }
        }
        if (typeof args.currentElements['project6'] === 'object') {
            let progress = args.currentElements['project6'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation6 !== undefined) {
                    _mobileAnimation6.pause();
                }
            }, 500);
            if (_mobileAnimation6 !== undefined && args.direction == "down") {
                _mobileAnimation6.setDirection(1);
                _mobileAnimation6.play();
            }
            else {
                if (_mobileAnimation6 !== undefined) {
                    _mobileAnimation6.setDirection(-1);
                    _mobileAnimation6.play();
                }
            }
        }
        if (typeof args.currentElements['project7'] === 'object') {
            let progress = args.currentElements['project7'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation7 !== undefined) {
                    _mobileAnimation7.pause();
                }
            }, 500);
            if (_mobileAnimation7 !== undefined && args.direction == "down") {
                _mobileAnimation7.setDirection(1);
                _mobileAnimation7.play();
            }
            else {
                if (_mobileAnimation7 !== undefined) {
                    _mobileAnimation7.setDirection(-1);
                    _mobileAnimation7.play();
                }
            }
        }
        if (typeof args.currentElements['project8'] === 'object') {
            let progress = args.currentElements['project8'].progress;
            var mTimer;
            clearTimeout(mTimer);
            mTimer = setTimeout(function () {
                if (_mobileAnimation8 !== undefined) {
                    _mobileAnimation8.pause();
                }
            }, 500);
            if (_mobileAnimation8 !== undefined && args.direction == "down") {
                _mobileAnimation8.setDirection(1);
                _mobileAnimation8.play();
            }
            else {
                if (_mobileAnimation8 !== undefined) {
                    _mobileAnimation8.setDirection(-1);
                    _mobileAnimation8.play();
                }
            }
        }
    });
}


// Draw image
const drawImageHandler = () => {
    if (document.querySelector('[data-hover-path]')) {
        const app = new owd.App();
        app.run();
    }
    $('.pageContent__projects canvas').attr('data-scroll', '');
    $('.pageContent__projects canvas').attr('data-scroll-sticky', '');
    $('.pageContent__projects canvas').attr('data-scroll-target', '#page-content');
    $('.aboutUs__midContent--text canvas').attr('data-scroll', '');
    $('.aboutUs__midContent--text canvas').attr('data-scroll-sticky', '');
    $('.aboutUs__midContent--text canvas').attr('data-scroll-target', '#drawend');
}


// Nav data
const navData = () => {
    fetch(cmsLink + '/wp-json/wp/v2/work/?per_page=20')
        .then(function (response) {
            return response.json();
        })
        .then(function (data) {
            const navData = data
            const navClinetName = document.querySelectorAll('.client__name')
            const navId = document.querySelectorAll('[data-id]')
            const navAgencyId = document.querySelectorAll('[data-agency-id]')
            const navHeaderId = document.querySelectorAll('[data-header-id]')
            const navFooterId = document.querySelectorAll('[data-footer-id]')
            const navAgencyName = document.querySelectorAll('.agency__name')
            navData.forEach((item, index) => {
                navClinetName[index].innerHTML = item.ACF.client_name
                navHeaderId[index].innerHTML = item.ACF.client_name
                navId[index].dataset.id = item.id
                navAgencyId[index].dataset.agencyId = item.id
                navHeaderId[index].dataset.headerId = item.id
                navFooterId[index].dataset.footerId = item.id
                navAgencyName[index].innerHTML = item.ACF.agency_name
                navFooterId[index].innerHTML = item.ACF.agency_name
                setTimeout(() => {
                    navClinetName.forEach(target => {
                        const results = Splitting({ target: target, by: 'chars' });
                    });
                    navAgencyName.forEach(target => {
                        const results = Splitting({ target: target, by: 'chars' });
                    });
                }, 600);
            });
            setTimeout(() => {
                workHoverHanlder()
                singleWorkNav()
                if ($('.workPreloader').length > 0) {
                    setTimeout(() => {
                        $('.workPreloader').addClass('hide')
                    }, 2000);
                }
                if ($('.projectPreloader').length > 0) {
                    setTimeout(() => {
                        $('.projectPreloader').addClass('hide');
                    }, 2000);
                }
                if ($('.usPreloader').length > 0) {
                    setTimeout(() => {
                        $('.usPreloader').addClass('hide')
                    }, 2000);
                }
                if ($('.notFoundPreloader').length > 0) {
                    setTimeout(() => {
                        $('.notFoundPreloader').addClass('hide')
                    }, 2000);
                }
            }, 1000);
        })
    $('body').addClass('nav-loaded')
}
navData()

// Work hover & Menu nav handler
const workHoverHanlder = () => {
    setTimeout(() => {
        if ($('[data-title]')) {
            const worklist = document.querySelectorAll('[data-title]')
            const oldNav = document.querySelectorAll('.fixed__menuLink .char')
            const newNav = document.querySelectorAll('.new__menuLink .char')
            const navIndex = document.querySelectorAll('[data-id]')
            const navAgencyIndex = document.querySelectorAll('[data-agency-id]')
            const navHeaderIndex = document.querySelectorAll('[data-header-id]')
            const navFooterIndex = document.querySelectorAll('[data-footer-id]')
            worklist.forEach((item, index) => {
                item.addEventListener('click', () => {
                    $('.navigation').removeClass('zBellow')
                    oldNav.forEach(oitem => {
                        gsap.to(oitem, {
                            duration: 1,
                            x: 35,
                            skewY: 30,
                            opacity: 0,
                            ease: "Expo.easeOut",
                        });
                    });
                    newNav.forEach(nitem => {
                        gsap.fromTo(nitem, {
                            x: -30,
                            skewY: -30,
                            opacity: 0,
                        }, {
                            x: 0,
                            skewY: 0,
                            opacity: 1,
                            duration: 1.5,
                            ease: "Expo.easeOut",
                        });
                    });
                    navIndex.forEach((nitem, index) => {
                        nitem.classList.add('hide')
                        if (item.dataset.index == navIndex[index].dataset.id) {
                            navIndex[index].classList.remove('hide')
                        }
                    });
                    navAgencyIndex.forEach((nitem, index) => {
                        nitem.classList.add('hide')
                        if (item.dataset.index == navAgencyIndex[index].dataset.agencyId) {
                            navAgencyIndex[index].classList.remove('hide')
                        }
                    });
                    navHeaderIndex.forEach((nitem, index) => {
                        nitem.classList.add('hide')
                        if (item.dataset.index == navHeaderIndex[index].dataset.headerId) {
                            navHeaderIndex[index].classList.remove('hide')
                        }
                    });
                    navFooterIndex.forEach((nitem, index) => {
                        nitem.classList.add('hide')
                        if (item.dataset.index == navFooterIndex[index].dataset.footerId) {
                            navFooterIndex[index].classList.remove('hide')
                        }
                    });

                })
                item.addEventListener('mouseenter', () => {
                    $('.navigation').addClass('zBellow')
                })
                item.addEventListener('mouseleave', () => {
                    $('.navigation').removeClass('zBellow')
                })

            });
        }
    }, 1000);

}

const detailsNavHandler = () => {
    setTimeout(function () {
        if (window.location.href.includes('project')) {
            setTimeout(function () {
                $('.navigation').addClass('zBellow')
                $('.navigation').addClass('peNone')
            }, 1200);
        } else {
            $('.navigation').removeClass('zBellow')
            $('.navigation').removeClass('peNone')
        }
    }, 250);
}
detailsNavHandler()
const navResetHandler = () => {
    $('.navigation').removeClass('zBellow')
    const pageLinks = document.querySelectorAll('.page__link')
    pageLinks.forEach(item => {
        item.addEventListener('click', () => {
            if ($('.navigation').hasClass('zBellow')) {
                $('.navigation').removeClass('zBellow')
                $('.navigation').removeClass('peNone')
            }
            gsap.fromTo('.fixed__menuLink .char', {
                x: 30,
                skewY: 30,
                opacity: 0,
                duration: 1.5,
                ease: "Expo.easeOut",
            }, {
                x: 0,
                skewY: 0,
                opacity: 1,
                duration: 1.5,
                ease: "Expo.easeOut",
            });
            gsap.to('.new__menuLink .char', {
                x: -30,
                skewY: -30,
                opacity: 0,
                duration: 1,
                ease: "Expo.easeOut",
            });
        })
    });

}

const navResetHandler2 = () => {
    if ($('.navigation').hasClass('zBellow')) {
        $('.navigation').removeClass('zBellow')
        $('.navigation').removeClass('peNone')
    }
    gsap.fromTo('.fixed__menuLink .char', {
        x: 30,
        skewY: 30,
        opacity: 0,
        duration: 1.5,
        ease: "Expo.easeOut",
    }, {
        x: 0,
        skewY: 0,
        opacity: 1,
        duration: 1.5,
        ease: "Expo.easeOut",
    });
    gsap.to('.new__menuLink .char', {
        x: -30,
        skewY: -30,
        opacity: 0,
        duration: 1,
        ease: "Expo.easeOut",
    });
}




// Work page video handler
const videoHandler = () => {
    if ($('.video')) {
        fetch(cmsLink + '/wp-json/wp/v2/work/?per_page=100')
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                const videoUrl = data
                const videoNewUrl = document.querySelectorAll('[data-source]');
                const currenturl = document.querySelectorAll('.wVideo');
                const videoOldUrl = document.querySelectorAll('[data-original]');

                videoUrl.forEach((item, index) => {
                    videoNewUrl[index].dataset.source = item.ACF.mp4_video.url
                    currenturl[index].src = item.ACF.mp4_video.url
                    videoOldUrl[index].dataset.original = item.ACF.mp4_video.url
                });
                setTimeout(() => {
                    let hoverTimeout
                    videoNewUrl.forEach(elem => {

                        let groupv = document.querySelectorAll('.wVideo');
                        //Add mouseover event to each video element
                        elem.addEventListener("mouseenter", function () {
                            //Wait period of time until setting videos
                            hoverTimeout = setTimeout(() => {
                                let currTime = this.children[0].children[0].currentTime
                                //For each video element, replace the source and load video
                                groupv.forEach(e => {
                                    $('.wVideo').attr('src', this.dataset.source);
                                    e.currentTime = currTime
                                    e.load();
                                    setTimeout(function () { e.play(); }, 50);
                                });
                            }, 600);
                        });

                        //On mouseout revert back to original
                        elem.addEventListener("mouseleave", function () {
                            groupv.forEach(e => {
                                //Clear the timeout so it never runs
                                clearTimeout(hoverTimeout)
                                setTimeout(() => {
                                    this.children[0].children[0].dataset.originalT = this.children[0].children[0].currentTime

                                    if (e.src !== e.dataset.original) {
                                        e.setAttribute('src', e.dataset.original)
                                        e.currentTime = (e.dataset.originalT ? e.dataset.originalT : 0)
                                        e.load();
                                    }
                                    setTimeout(function () {
                                        e.pause();
                                    }, 50);

                                }, 600);

                            });
                        });
                    });

                    const workListWrapper = document.getElementsByClassName("work__list")[0]
                    let workListTimeout

                    workListWrapper.addEventListener("mouseenter", function () {

                        workListWrapper.addEventListener("mouseleave", function removeWorkLeaveEvent(e) {
                            clearTimeout(workListTimeout)
                        })
                        workListTimeout = setTimeout(() => {

                            workListWrapper.addEventListener("mouseleave", function () {
                                let groupv = document.querySelectorAll('.wVideo');

                                groupv.forEach(e => {
                                    e.setAttribute('src', e.dataset.original)
                                    e.dataset.originalT = 0
                                    e.load();
                                })
                            }, { once: true })
                        }, 600);
                    })
                }, 400);
            })
    }
}



// Details page video handler
const detailsVideoHandler = () => {
    $('body').addClass('videoModeOn')
    if ($('.video__banner').length > 0) {
        // Video controls
        let videoWrapper = document.querySelector('.video__banner')
        videoWrapper.addEventListener('mouseenter', () => { cursor.enter() })
        videoWrapper.addEventListener('mouseleave', () => { cursor.leave() })
        var playerM, vidWrap;
        $(document).on('click', '.video__banner:not(.video_loading) .video_overlay', function () {
            var thOv = $(this);
            vidWrap = thOv.closest('.video__banner');
            var vid = vidWrap.find('.vim_video');
            playerM = new Player(vid);
            if (vidWrap.hasClass('video_playing')) {


                let mainPlayer = document.querySelector('.player')
                $('.videoState__text').text("Play")
                vidWrap.removeClass("video_playing");
                playerM.pause();
                thOv.attr('data-cursor', 'Play');
            } else {
                if (!vidWrap.hasClass('video_started')) {
                    vidWrap.addClass("video_loading");
                    $('.videoState__text').text("Loading")
                }
                playerM.play().then(function (id) {
                    thOv.attr('data-cursor', 'Pause');
                    vidWrap.removeClass("video_loading").addClass("video_playing video_started");
                    $('.videoState__text').text("Pause")
                    $('.alt2videoState__text').text("Play")
                    $('.alt1videoState__text').text("Play")

                    if (!$('.videoInner__controls').hasClass('vedioMode')) {
                        setTimeout(function () {
                            $('.videoInner__controls').addClass('vedioMode')
                            $('.videoState__text').addClass('vedioMode')
                        }, 3000);
                        document.addEventListener('mousemove', function () {
                            $('.videoInner__controls').removeClass('vedioMode')
                            $('.videoState__text').removeClass('vedioMode')
                        })
                    }

                    return playerM.play();

                });
                playerM.on('timeupdate', function (data) {
                    vidWrap.find('.draggable-point').css("left", data.percent * 100 + "%");
                    vidWrap.find('.audio-progress-bar').css("width", data.percent * 100 + "%");
                });

                playerM.on('ended', function (data) {
                    thOv.attr('data-cursor', 'Play');
                    vidWrap.removeClass("video_playing fullscreen");
                    $('body').removeClass('fullscreen_mode hide_controls');
                    $('.videoInner__controls').removeClass('vedioMode')
                    $('.videoState__text').removeClass('vedioMode')
                    if (screenfull.isEnabled) {
                        screenfull.exit(vidWrap[0]);
                    }
                    $(".theBall span").text("Play");
                    $('.videoState__text').text("Play")
                });
            }
        });

        //VOLUME BAR
        //volume bar event
        var videoVolumeDrag = false;
        $(document).on('mousedown', '.video_sound', function (e) {
            videoVolumeDrag = true;
            $('.video_started .video_sound').removeClass('muted');
            updateVolume(e.pageX);
        });
        $(document).on('mouseup', function (e) {
            if (videoVolumeDrag) {
                videoVolumeDrag = false;
                updateVolume(e.pageX);
            }
        });
        $(document).on('mousemove', function (e) {
            if (videoVolumeDrag) {
                updateVolume(e.pageX);
            }
        });
        var updateVolume = function (x, vol) {
            var volume = $('.video_started .video_sound_line');
            var percentage;
            if (vol) {
                percentage = vol * 100;
            } else {
                var position = x - volume.offset().left;
                percentage = 100 * position / volume.width();
            }

            if (percentage > 100) {
                percentage = 100;
            }
            if (percentage < 0) {
                percentage = 0;
            }

            //update volume bar and video volume
            $('.video_started .video_sound_control').css('width', percentage + '%');
            playerM.setVolume(percentage / 100);

            //change sound icon based on volume
            if (percentage / 100 == 0) {
                $('.video_started .video_sound').removeClass('sound2').addClass('muted');
            } else if (playerM.getVolume() > 0.5) {
                $('.video_started .video_sound').removeClass('muted').addClass('sound2');
            } else {
                $('.video_started .video_sound').removeClass('muted').removeClass('sound2');
            }
        };

        var videoPosDrag = false;
        $(document).on('mousedown', '.audio-progress-wrap', function (e) {
            videoPosDrag = true;
            var parEl = $(this).closest('.video_wrap');
            updatePos(e.pageX, parEl);
        }).on('mouseup', '.audio-progress-wrap', function (e) {
            var parEl = $(this).closest('.video_wrap');
            if (videoPosDrag) {
                videoPosDrag = false;
                updatePos(e.pageX, parEl);
            }
        }).on('mousemove', '.audio-progress-wrap', function (e) {
            var parEl = $(this).closest('.video_wrap');
            if (videoPosDrag) {
                updatePos(e.pageX, parEl);
            }
        });

        var updatePos = function (x, elem) {
            playerM.getPaused().then(function (paused) {
                if (!paused) {
                    return playerM.pause().then(function () {
                        return false;
                    });
                }
                return true;
            });
            var volume = $('.video_started .audio-progress');
            var percentage;
            var position = x - volume.offset().left;
            percentage = 100 * position / volume.width();

            if (percentage > 100) {
                percentage = 100;
            }
            if (percentage < 0) {
                percentage = 0;
            }

            volume.find('.draggable-point').css("left", percentage + "%");
            volume.find('.audio-progress-bar').css('width', percentage + '%');
            playerM.getDuration().then(function (duration) {
                playerM.setCurrentTime(duration * percentage / 100).then(function () {
                    if (elem.hasClass("video_playing")) {
                        return playerM.getPaused().then(function (paused) {
                            if (paused) {
                                return playerM.play().then(function () {
                                    return playerM.play();
                                }).catch(function (error) {
                                    elem.removeClass("video_playing");
                                    playerM.pause();
                                    elem.find('.video_overlay').attr('data-cursor', 'Play');
                                    $('.videoState__text').text("Play")
                                });
                            }
                        });
                    }
                });
            });

        };

        //Video full screen
        var curPos;
        var timeout, videotimer;
        var scrollbar;
        $(document).on('click', '.full_screen_btn', function (e) {
            clearTimeout(videotimer);
            vidWrap = $(this).closest('.videoInner');
            // curPos = scrollbar.offset.y;
            // vidWrap.find('.video_inner').css('top', 0);
            if ($(window).width() < 1200) {
                $('body').toggleClass('fullscreen_mode');
                vidWrap.toggleClass('fullscreen');
            } else {
                toggleFullscreen();
            }
        });

        $(document).on('click', '.full_screen_btn2', function (e) {
            clearTimeout(videotimer);
            vidWrap = $(this).closest('.singleBanner__video');
            // curPos = scrollbar.offset.y;
            vidWrap.find('.video_inner').css('top', 0);
            if ($(window).width() < 1200) {
                $('body').toggleClass('altfullscreen_mode');
                vidWrap.toggleClass('fullscreen');
            } else {
                alttoggleFullscreen();
                vidWrap.toggleClass('fullscreenon');
            }
        });

        $(document).on('click', '.full_screen_btn3', function (e) {
            clearTimeout(videotimer);
            vidWrap = $(this).closest('.singleBanner__video');
            // curPos = scrollbar.offset.y;
            vidWrap.find('.video_inner').css('top', 0);
            if ($(window).width() < 1200) {
                $('body').toggleClass('altfullscreen_mode');
                vidWrap.toggleClass('fullscreen');
            } else {
                alt2toggleFullscreen();
                vidWrap.toggleClass('fullscreenon');
            }
        });

        function toggleFullscreen() {
            if (!$('body').hasClass('fullscreen_mode')) {
                if (screenfull.isEnabled) {
                    screenfull.request(vidWrap[0]);
                    $('.full_screen_btn').text('EXIT')
                }
            } else {
                if (screenfull.isEnabled) {
                    screenfull.exit(vidWrap[0]);
                }
                $('.full_screen_btn').text('FULL SCREEN')
                $('body').attr('style', '');
            }
            $('body').toggleClass('fullscreen_mode');
        }
        function alttoggleFullscreen() {
            if (!$('body').hasClass('altfullscreen_mode')) {
                if (screenfull.isEnabled) {
                    screenfull.request(vidWrap[0]);
                    $('.full_screen_btn2').text('EXIT')
                }
            } else {
                if (screenfull.isEnabled) {
                    screenfull.exit(vidWrap[0]);
                }
                $('.full_screen_btn2').text('FULL SCREEN')
                $('body').attr('style', '');
            }
            $('body').toggleClass('altfullscreen_mode');
        }

        function alt2toggleFullscreen() {
            if (!$('body').hasClass('altfullscreen_mode')) {
                if (screenfull.isEnabled) {
                    screenfull.request(vidWrap[0]);
                    $('.full_screen_btn3').text('EXIT')
                }
            } else {
                if (screenfull.isEnabled) {
                    screenfull.exit(vidWrap[0]);
                }
                $('.full_screen_btn3').text('FULL SCREEN')
                $('body').attr('style', '');
            }
            $('body').toggleClass('altfullscreen_mode');
        }


        if ($(window).width() > 1200) {
            screenfull.on('change', function (event) {
                if ($('body').hasClass('fullscreen_mode') && !screenfull.isFullscreen) {
                    $('body').removeClass('fullscreen_mode hide_controls').attr('style', '');
                    clearTimeout(videotimer);
                }
            });
        }

        $(document).keyup(function (e) {
            if ($('body').hasClass('fullscreen_mode') && e.keyCode == 32 && screenfull.isFullscreen) {
                e.preventDefault();
                if (vidWrap.hasClass('video_playing')) {
                    vidWrap.removeClass("video_playing");
                    playerM.pause();
                } else {
                    vidWrap.addClass("video_playing");
                    playerM.play();
                }
            }
        });
    }
    if ($('#altVideo1').length > 0) {
        let altWrapper = document.querySelector('.alt1')
        let alt2Wrapper = document.querySelector('.alt2')
        altWrapper.addEventListener('mouseenter', () => { cursor.enter() })
        alt2Wrapper.addEventListener('mouseenter', () => { cursor.enter() })
        altWrapper.addEventListener('mouseleave', () => { cursor.leave() })
        alt2Wrapper.addEventListener('mouseleave', () => { cursor.leave() })
        $(document).on('click', '#altVideo1:not(.video_loading) .alt1_overlay', function () {
            var thOv = $(this);
            vidWrap = thOv.closest('.alt1');
            var vid = vidWrap.find('.alt1_video');
            playerM = new Player(vid);
            if (vidWrap.hasClass('video_playing')) {
                $('.alt1videoState__text').text("Play")
                vidWrap.removeClass("video_playing");
                playerM.pause();
            } else {
                if (!vidWrap.hasClass('video_started')) {
                    vidWrap.addClass("video_loading");
                    $('.alt1videoState__text').text("Loading")
                }
                playerM.play().then(function (id) {
                    if (!$('.singleBanner__video--alt1').hasClass('vedioMode')) {

                        if(playerM.element.classList.contains("alt1_video")){
                            setTimeout(function () {
                                $('.singleBanner__video--alt1').addClass('vedioMode')
                            }, 2000);
                            if(!("ontouchstart" in document.documentElement)){
                                document.addEventListener('mousemove', function () {
                                    $('.singleBanner__video--alt1').removeClass('vedioMode')
                                })
                            }else{
                                $('.singleBanner__video--alt1').on('click', function() {
                                    if($('.singleBanner__video--alt1').hasClass('vedioMode')){
                                        $('.singleBanner__video--alt1').removeClass('vedioMode')
                                    }
                                })
                            }
                        }
                    }
                    $('.alt1videoState__text').text("Pause")
                    $('.videoState__text').text("Play")
                    vidWrap.removeClass("video_loading").addClass("video_playing video_started");
                    return playerM.play();
                });

                // thOv.closest('.home_page_video').find('.video_list_text').fadeOut();

                playerM.on('timeupdate', function (data) {
                    vidWrap.find('.draggable-point').css("left", data.percent * 100 + "%");
                    vidWrap.find('.audio-progress-bar').css("width", data.percent * 100 + "%");
                });

                playerM.on('ended', function (data) {
                    $('.alt1videoState__text').text("Play")
                    $('.singleBanner__video--alt1').removeClass('vedioMode')
                    vidWrap.removeClass("video_playing fullscreen");
                    $('body').removeClass('altfullscreen_mode hide_controls');
                    if (screenfull.isEnabled) {
                        screenfull.exit(vidWrap[0]);
                    }
                });
            }
        });
    }
    if ($('#altVideo2').length > 0) {
        $(document).on('click', '#altVideo2:not(.video_loading) .alt2_overlay', function () {
            var thOv = $(this);
            vidWrap = thOv.closest('.alt2');
            var vid = vidWrap.find('.alt2_video');
            playerM = new Player(vid);
            if (vidWrap.hasClass('video_playing')) {
                thOv.attr('data-cursor', 'Play');
                vidWrap.removeClass("video_playing");
                playerM.pause();
                $('.alt2videoState__text').text("Play")
            } else {
                if (!vidWrap.hasClass('video_started')) {
                    vidWrap.addClass("video_loading");
                    $('.alt2videoState__text').text("Loading")
                }
                playerM.play().then(function (id) {
                    if (!$('.singleBanner__video--alt2').hasClass('vedioMode')) {
                        if(playerM.element.classList.contains("alt2_video")){
                            setTimeout(function () {
                                $('.singleBanner__video--alt2').addClass('vedioMode')
                            }, 2000);
                            if(!("ontouchstart" in document.documentElement)){
                                document.addEventListener('mousemove', function () {
                                    $('.singleBanner__video--alt2').removeClass('vedioMode')
                                })
                            }else{
                                $('.singleBanner__video--alt2').on('click', function() {
                                    if($('.singleBanner__video--alt2').hasClass('vedioMode')){
                                        $('.singleBanner__video--alt2').removeClass('vedioMode')
                                    }
                                })
                            }
                        }
                    }
                    $('.alt2videoState__text').text("Pause")
                    $('.videoState__text').text("Play")
                    vidWrap.removeClass("video_loading").addClass("video_playing video_started");
                    return playerM.play();
                });

                // thOv.closest('.home_page_video').find('.video_list_text').fadeOut();

                playerM.on('timeupdate', function (data) {
                    vidWrap.find('.draggable-point').css("left", data.percent * 100 + "%");
                    vidWrap.find('.audio-progress-bar').css("width", data.percent * 100 + "%");
                });

                playerM.on('ended', function (data) {
                    vidWrap.removeClass("video_playing fullscreen");
                    $('body').removeClass('fullscreen_mode hide_controls');
                    $('.singleBanner__video--alt2').removeClass('vedioMode')
                    if (screenfull.isEnabled) {
                        screenfull.exit(vidWrap[0]);
                    }
                    $('.alt2videoState__text').text("Play")
                });
            }
        });
    }
}

let calcTarget
let tick
//Us page WebGl 

const aboutUswebGlHandler = () => {
    if (document.querySelectorAll('canvas.webgl').length > 0) {
        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('draco/')

        const gltfLoader = new GLTFLoader()
        gltfLoader.setDRACOLoader(dracoLoader)

        // const stats = new Stats()
        // stats.showPanel(0) // 0: fps, 1: ms, 2: mb, 3+: custom
        // document.body.appendChild(stats.dom)

        const cubeTextureLoader = new THREE.CubeTextureLoader()

        /**
         * Base
         */
        // Debug
        // const gui = new dat.GUI()
        const debugObject = {}

        // Canvas
        const canvas = document.querySelector('canvas.webgl')

        // Scene
        const scene = new THREE.Scene()

        /**
         * Update all materials
         */
        const updateAllMaterials = () => {
            scene.traverse((child) => {
                if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                    // child.material.envMap = environmentMap
                    child.material.envMapIntensity = debugObject.envMapIntensity
                    child.material.needsUpdate = true
                    child.castShadow = true
                    child.receiveShadow = true
                }
            })
        }


        /**
         * Environment map
         */
        const environmentMap = cubeTextureLoader.load([
            'textures/environmentMaps/0/px.jpg',
            'textures/environmentMaps/0/nx.jpg',
            'textures/environmentMaps/0/py.jpg',
            'textures/environmentMaps/0/ny.jpg',
            'textures/environmentMaps/0/pz.jpg',
            'textures/environmentMaps/0/nz.jpg'
        ])


        environmentMap.encoding = THREE.sRGBEncoding

        //scene.background = environmentMap
        scene.environment = environmentMap

        debugObject.envMapIntensity = 10
        // gui.add(debugObject, 'envMapIntensity').min(0).max(10).step(0.001).onChange(updateAllMaterials)



        /**
         * Models
         */
        gltfLoader.load(
            '/models/Private/glTFe/PImodels2022.gltf',
            (gltf) => {
                gltf.scene.scale.set(9, 9, 9)
                gltf.scene.position.set(0, -2, 0)
                gltf.scene.rotation.y = Math.PI * 0.45
                scene.add(gltf.scene)

                // gui.add(gltf.scene.rotation, 'y').min(- Math.PI).max(Math.PI).step(0.001).name('rotation')

                updateAllMaterials()
            }
        )


        /**
         * Lights
         */
        const directionalLight = new THREE.DirectionalLight('#ffffff', 2)
        directionalLight.castShadow = true
        directionalLight.shadow.camera.far = 13
        directionalLight.shadow.mapSize.set(1024, 1024)
        directionalLight.shadow.normalBias = 0.05
        directionalLight.position.set(-0.5, 4, -2.5)
        scene.add(directionalLight)

        // gui.add(directionalLight, 'intensity').min(0).max(10).step(0.001).name('lightIntensity')
        // gui.add(directionalLight.position, 'x').min(- 5).max(5).step(0.001).name('lightX')
        // gui.add(directionalLight.position, 'y').min(- 5).max(5).step(0.001).name('lightY')
        // gui.add(directionalLight.position, 'z').min(- 5).max(5).step(0.001).name('lightZ')

        /**
  * Sizes
  */

        let windowHalfX = window.innerWidth / 2;
        let windowHalfY = window.innerHeight / 2;


        const sizes = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        window.addEventListener('resize', () => {
            // Update sizes
            sizes.width = window.innerWidth
            sizes.height = window.innerHeight

            windowHalfX = window.innerWidth / 2;
            windowHalfY = window.innerHeight / 2;

            // Update camera
            camera.aspect = sizes.width / sizes.height
            camera.updateProjectionMatrix()

            // Update renderer
            renderer.setSize(sizes.width, sizes.height)
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
        })

        /**
         * Camera
         */
        // Base camera
        const camera = new THREE.PerspectiveCamera(18, sizes.width / sizes.height, 0.1, 100)
        camera.position.set(0, 2, - 16)
        scene.add(camera)

        // Controls
        const controls = new OrbitControls(camera, canvas)
        controls.enableDamping = true
        controls.minPolarAngle = 0;
        controls.maxPolarAngle = Math.PI * 0.5;
        //controls.minAzimuthAngle = 1; // default
        //controls.maxAzimuthAngle = -1; // default
        controls.autoRotate = false
        controls.minDistance = 17;
        controls.maxDistance = 17;
        //controls.noRotate = true;
        //controls.enabled = false;

        /**
  * Renderer
  */
        const renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            powerPreference: 'high-performance',
            antialias: true,
            alpha: true
        })
        renderer.physicallyCorrectLights = true
        renderer.outputEncoding = THREE.sRGBEncoding
        renderer.toneMapping = THREE.ReinhardToneMapping
        renderer.toneMappingExposure = 2
        renderer.shadowMap.enabled = true
        renderer.shadowMap.type = THREE.PCFSoftShadowMap
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

        // gui
        //     .add(renderer, 'toneMapping', {
        //         No: THREE.NoToneMapping,
        //         Linear: THREE.LinearToneMapping,
        //         Reinhard: THREE.ReinhardToneMapping,
        //         Cineon: THREE.CineonToneMapping,
        //         ACESFilmic: THREE.ACESFilmicToneMapping
        //     })
        //     .onFinishChange(() => {
        //         renderer.toneMapping = Number(renderer.toneMapping)
        //         updateAllMaterials()
        //     })
        // gui.add(renderer, 'toneMappingExposure').min(0).max(10).step(0.001)

        /**
         * Animate
         */

        let targetX = 10
        let targetY = 10

        calcTarget = function(event){
            targetX = (event.clientX - windowHalfX) * .014;
            targetY = (event.clientY) * .009;
        }

        setTimeout(() => {
            document.addEventListener("mousemove",calcTarget)
        }, 1000);

        let tarXNegCamPosX = 10
        let tarYNegCamPosY = 10

        controls.enabled = false;

        tick = function() {
            if(document.querySelectorAll("canvas.webgl").length > 0){
                tarXNegCamPosX = targetX - camera.position.x
                tarYNegCamPosY = targetY - camera.position.y
    
                if ((Math.abs(tarXNegCamPosX) > .2) || (Math.abs(tarYNegCamPosY) > .2)) {
    
                    camera.position.x += .06 * (tarXNegCamPosX);
                    camera.position.y += .06 * (tarYNegCamPosY);
    
                    directionalLight.position.x += .06 * (targetX - directionalLight.position.x);
    
                    // Update controls
                    controls.update()
    
                    camera.lookAt(scene.position);
    
                    // Render
                    renderer.render(scene, camera)
                }
            }

            requestAnimationFrame(tick)

        }

        tick()
    }
}


// form show hide
const contactHandler = () => {
    $('.show__form').click(function () {
        setTimeout(() => {
            $('#user_message').focus()
        }, 500);
        $('.contact__textContent').addClass('hide')
        $('.contact__form').addClass('show')
        if ($('.aboutUs').length > 0) {
            $('.dsMenu').addClass('snGradient')
            $('.aboutUs').addClass('snGradient')
            $('.header').addClass('snGradient')
            $('.footer').addClass('snGradient')
        }
        lscroll.scrollTo('right')
    })
    $('.close__form').click(function () {
        $('.contact__form').removeClass('show')
        $('.contact__textContent').removeClass('hide')
        if ($('.step1').hasClass('completed')) {
            $('.step1').removeClass('completed')
        }
        if ($('.step2').hasClass('show')) {
            $('.step2').removeClass('show')
        }
        if ($('.step2').hasClass('completed')) {
            $('.step2').removeClass('completed')
        }

        if ($('.step3').hasClass('show')) {
            $('.step3').removeClass('show')
        }
        if ($('.aboutUs').length > 0) {
            $('.dsMenu').removeClass('snGradient')
            $('.aboutUs').removeClass('snGradient')
            $('.header').removeClass('snGradient')
            $('.footer').removeClass('snGradient')
        }
    })

    $('.next1').click(function () {
        $('.step1').addClass('completed')
        $('.step2').addClass('show')
        if ($('#user_name').val().length < 1) {
            $('#user_name').typetype('Hi, my name is ')
        }
        setTimeout(() => {
            $('#user_name').focus()
        }, 500);

        // create invisible dummy input to receive the focus first
        const fakeInput = document.createElement('input')
        fakeInput.setAttribute('type', 'text')
        fakeInput.style.position = 'absolute'
        fakeInput.style.opacity = 0
        fakeInput.style.height = 0
        fakeInput.style.fontSize = '16px' // disable auto zoom
        let targetInput = document.getElementById('user_name')


        // you may need to append to another element depending on the browser's auto 
        // zoom/scroll behavior
        document.body.prepend(fakeInput)

        // focus so that subsequent async focus will work
        fakeInput.focus()

        setTimeout(() => {

            // now we can focus on the target input
            targetInput.focus()

            // cleanup
            fakeInput.remove()

        }, 1000)

    })
    $('.next2').click(function () {
        $('.step2').addClass('completed')
        $('.step3').addClass('show')
        if ($('#user_email').val().length < 1) {
            $('#user_email').typetype('Contact me on ')
        }
        setTimeout(() => {

            $('#user_email').focus()
        }, 500);
        // create invisible dummy input to receive the focus first
        const fakeInput = document.createElement('input')
        fakeInput.setAttribute('type', 'text')
        fakeInput.style.position = 'absolute'
        fakeInput.style.opacity = 0
        fakeInput.style.height = 0
        fakeInput.style.fontSize = '16px' // disable auto zoom
        let targetInput = document.getElementById('user_email')

        // you may need to append to another element depending on the browser's auto 
        // zoom/scroll behavior
        document.body.prepend(fakeInput)

        // focus so that subsequent async focus will work
        fakeInput.focus()

        setTimeout(() => {

            // now we can focus on the target input
            targetInput.focus()

            // cleanup
            fakeInput.remove()

        }, 1000)
    })


    $('.send').click(function () {

        $('.contact__form').removeClass('show')
        $('.contact__textContent').removeClass('hide')
        if ($('.aboutUs').length > 0) {
            $('.dsMenu').removeClass('snGradient')
            $('.aboutUs').removeClass('snGradient')
            $('.header').removeClass('snGradient')
            $('.footer').removeClass('snGradient')
        }
        $('.contactTitle').text("Message Sent!")
        $('.contact__text').addClass('hide')
        $('.show__form').addClass('hide')

        setTimeout(() => {
            $('.contactTitle').text("")
            $('.contact__text').removeClass('hide')
            $('.show__form').removeClass('hide')
        }, 3000);
    })
}

const formHandler = () => {
    const formSubmissionHandler = (event) => {
        event.preventDefault();

        const formElement = event.target,
            { action, method } = formElement,
            body = new FormData(formElement);

        fetch(action, {
            method,
            body
        })
            .then((response) => response.json())
            .then((response) => {
                // Determine if the submission is not valid
                if (isFormSubmissionError(response)) {
                    // Handle the case when there are validation errors
                }
                // Handle the happy path
            })
            .catch((error) => {
                // Handle the case when there's a problem with the request
            });
    };
    const formElement = document.querySelector("form");

    formElement.addEventListener("submit", formSubmissionHandler);
    $('.send').click(function () {
        if ($('.aboutUs').length > 0) {

            const userEmail = document.getElementById('user_email').value
            const userName = document.getElementById('user_name').value
            const userMessage = document.getElementById('user_message').value
            Email.send({
                Host: "smtp.mailtrap.io",
                Username: "e4b7b02610fcd0",
                Password: "fc9f5f75eff29a",
                To: 'neembhaiyahman67@gmail.com',
                From: userEmail,
                Subject: "This is the subject",
                Body: userMessage
            }).then(
            );
            $('.pageContent__menu').removeClass('snGradient')
            $('.aboutUs').removeClass('snGradient')
            $('.header').removeClass('snGradient')
            $('.footer').removeClass('snGradient')
        }
    })
}

const resetColor = () => {
    $('.dsMenu').removeClass('snGradient')
    $('.aboutUs').removeClass('snGradient')
    $('.header').removeClass('snGradient')
    $('.footer').removeClass('snGradient')
}

contactHandler()

// Live time & date
const dateHanler = () => {

    if ($('.datetime').length > 0) {
        function GetClock() {
            var d = new Date();
            var nmonth = d.getMonth(), ndate = d.getDate(), nyear = d.getFullYear();
            var nhour = d.getHours(), nmin = d.getMinutes(), nsec = d.getSeconds();
            if (nmin <= 9) nmin = "0" + nmin
            if (nsec <= 9) nsec = "0" + nsec;
            if ($('.datetime').length > 0) {
                document.getElementById('date_time').innerHTML = "<div class='one-date'>" + ndate + "</div>/<div class='one-date'>" + (nmonth + 1) + "</div>/<div class='one-date year'>" + nyear + "</div><div class='one-date'>" + nhour + "</div>:<div class='one-date'>" + nmin + "</div>:<div class='one-date'>" + nsec + "</div>";
            }

        }


        GetClock();
        setInterval(GetClock, 1000);
    }
}

dateHanler()

//Redirect to home page
function redirectToHome() {
    barba.go("/")
    homeBtnRemoveEvents()
}

// Project page home prompt
const scrPrompt = document.getElementById("scrPrompt")

// Move trailing cursor on mousemove
function scrPromptMouse(e) {
    gsap.to(scrPrompt.children, {
        y: e.y,
        x: e.x
    })
}

function homeScrPrompt(){
    scrPrompt.innerHTML = ` <span style="margin-left: 2.8rem;">S</span>
                            <span>C</span>
                            <span>R</span>
                            <span>O</span>
                            <span>L</span>
                            <span>L</span>
                            <span>!</span> `

    for(let i = 0; i < scrPrompt.children.length; i++){
        let timing = ((i + .4) / 12)
        scrPrompt.children[scrPrompt.children.length - (i + 1)].style.transition = `opacity ${timing}s linear, transform ${(scrPrompt.children.length - (i + 1)) * .01}s linear`
    }

    document.addEventListener("mousemove",scrPromptMouse)

    let mouseWheelCount = 0
    setTimeout(() => {
        // if user hasnt scrolled from initial pos
        if(mouseWheelCount <= 30){
            scrPrompt.style.display = "block"
            gsap.to(scrPrompt, {opacity: 1, duration: .8, delay: 2})
        }
    }, 4500);

    // destroy cursor trail if user scrolls
    function checkScrPos(){
        if(mouseWheelCount > 30){
            document.removeEventListener("mousemove", scrPromptMouse)
            document.removeEventListener("mousewheel", checkScrPos)

            for(let i = 0; i < scrPrompt.children.length; i++){
                let timing = ((i + .4) / 10)

                scrPrompt.children[scrPrompt.children.length - (i + 1)].style.transition = `opacity ${timing}s linear, transform ${(i + 2) * .01}s linear`
                scrPrompt.children[i].style.opacity = 0
            }
            scrPrompt.classList.add("master-off")
        }

        mouseWheelCount++
    }
    document.addEventListener("mousewheel", checkScrPos)
}

function homeBtnAddEvents() {
    cursor.enter()
    //Mousemove eventlistener
    promptParent.addEventListener("mousemove", scrPromptMouse)
    //Show cursor trail
    gsap.to(scrPrompt, { delay: 0, duration: .15, opacity: 1 })
    //Add redirect
    promptParent.addEventListener("click", redirectToHome)
}

function homeBtnRemoveEvents() {
    cursor.leave()
    //Mousemove eventlistener
    promptParent.removeEventListener("mousemove", scrPromptMouse)
    //Hide cursor trail
    gsap.to(scrPrompt, { duration: .15, opacity: 0 })
    //Remove redirect
    promptParent.removeEventListener("click", redirectToHome)
}

function projectHome() {
    scrPrompt.innerHTML = ` <span style="transition: transform .01s linear;">GO</span>
                            <span style="transition: transform .04s linear;">HOME</span>`

    window.promptParent = document.getElementById("promptParent")
    window.promptChild = document.getElementsByClassName("hideHomePrompt")

    if (promptParent) {
        document.getElementsByClassName("c-scrollbar")[0].classList.add("hideHomePrompt")

        for (let i = 0; i < promptChild.length; i++) {
            //When user enters video area- hide cursor, remove events
            promptChild[i].addEventListener("mouseenter", function () {

                homeBtnRemoveEvents()

                //When user leaves video area- reveal cursor, add events
                promptChild[i].addEventListener("mouseleave", function () {

                    homeBtnAddEvents()

                }, { once: true })
            })
        }

        //Add events by default
        homeBtnAddEvents();
        gsap.to(scrPrompt, { delay: .5, duration: .15, opacity: 0 })
    }
};
// projectHome();

// 404 error 

const notFoundWebgl = () => {
    if ($('.notFound').length > 0) {

        lscroll.stop()

        const MOBILE_BREAKPOINT = 800
        const DEFAULT_FONT_FAMILY = 'GoshaSans'
        const BORDER_PADDING = innerWidth > MOBILE_BREAKPOINT ? 40 : 30
        const START_COLOR = '#fff'
        const startColorRGB = hexRgb(START_COLOR, { format: 'array' })
        const BACKGROUND_COLOR = '#333'
        const PERSIST_COLOR = [
            startColorRGB[0] / 255,
            startColorRGB[1] / 255,
            startColorRGB[2] / 255,
        ]
        const TARGET_PERSIST_COLOR = [...PERSIST_COLOR]

        const OPTIONS = {
            text: '404',
            noiseFactor: 8.6,
            noiseScale: 0.003,
            rgbPersistFactor: 0.98,
            alphaPersistFactor: 0.97,
            color: START_COLOR,
            borderColor: MOBILE_BREAKPOINT > 800 ? '#111' : '#454545',
            showBorder: false,
            animateColor: false,
            fontFamily: DEFAULT_FONT_FAMILY,
        }

        const fontFamilies = []
        const mousePos = [0, 0]
        const targetMousePos = [0, 0]

        const renderer = new THREE.WebGLRenderer()
        {
            renderer.setClearColor(new THREE.Color(BACKGROUND_COLOR))
            // renderer.setClearAlpha(0)
            document.getElementsByClassName('notFound')[0].appendChild(renderer.domElement)
        }

        const clock = new THREE.Clock()
        const scene = new THREE.Scene()
        const fluidScene = new THREE.Scene()
        // const gui = new dat.GUI()

        const orthoCamera = new THREE.OrthographicCamera(
            -innerWidth / 2,
            innerWidth / 2,
            innerHeight / 2,
            -innerHeight / 2,
            0.1,
            10,
        )
        {
            orthoCamera.position.set(0, 0, 1)
            orthoCamera.lookAt(new THREE.Vector3(0, 0, 0))
        }

        const texCanvas = document.createElement('canvas')
        const texCtx = texCanvas.getContext('2d')

        let fluidRenderTarget0 = new THREE.WebGLRenderTarget(
            renderer.domElement.clientWidth,
            renderer.domElement.clientHeight,
        )
        let fluidRenderTarget1 = fluidRenderTarget0.clone()

        const fullscreenQuadGeometry = new THREE.PlaneBufferGeometry(innerWidth, innerHeight)
        const fullscreenQuadMaterial = new THREE.ShaderMaterial({
            uniforms: {
                sampler: { value: null },
                time: { value: 0 },
                aspect: { value: innerWidth / innerHeight },
                mousePos: { value: new THREE.Vector2(-1, 1) },
                noiseFactor: { value: OPTIONS.noiseFactor },
                noiseScale: { value: OPTIONS.noiseScale },
                rgbPersistFactor: { value: OPTIONS.rgbPersistFactor },
                alphaPersistFactor: { value: OPTIONS.alphaPersistFactor },
            },
            vertexShader: baseVertex,
            fragmentShader: persistenceFragment,
            transparent: true,
        })
        const fullscreenQuad = new THREE.Mesh(fullscreenQuadGeometry, fullscreenQuadMaterial)
        fluidScene.add(fullscreenQuad)
        const fullscreenBorderVertices = new Float32Array(4 * 2)
        fullscreenBorderVertices[0] = -innerWidth / 2 + BORDER_PADDING
        fullscreenBorderVertices[1] = innerHeight / 2 - BORDER_PADDING

        fullscreenBorderVertices[2] = innerWidth / 2 - BORDER_PADDING
        fullscreenBorderVertices[3] = innerHeight / 2 - BORDER_PADDING

        fullscreenBorderVertices[4] = innerWidth / 2 - BORDER_PADDING
        fullscreenBorderVertices[5] = -innerHeight / 2 + BORDER_PADDING

        fullscreenBorderVertices[6] = -innerWidth / 2 + BORDER_PADDING
        fullscreenBorderVertices[7] = -innerHeight / 2 + BORDER_PADDING

        const fullscreenBorderGeometry = new THREE.BufferGeometry()
        fullscreenBorderGeometry.setAttribute(
            'position',
            new THREE.BufferAttribute(fullscreenBorderVertices, 2),
        )
        const fullscreenBorderMaterial = new THREE.LineBasicMaterial({
            color: OPTIONS.borderColor,
        })
        const fullscreenBorderMesh = new THREE.LineLoop(
            fullscreenBorderGeometry,
            fullscreenBorderMaterial,
        )

        // scene.add(fullscreenBorderMesh)

        const planeUnit = innerWidth > innerHeight ? innerHeight : innerWidth
        const labelGeometry = new THREE.PlaneBufferGeometry(planeUnit, planeUnit)
        const labelMaterial = new THREE.ShaderMaterial({
            uniforms: {
                sampler: { value: null },
                color: { value: new THREE.Vector3(1, 1, 1) },
            },
            vertexShader: baseVertex,
            fragmentShader: textFragment,
            transparent: true,
        })
        const labelMesh = new THREE.Mesh(labelGeometry, labelMaterial)
        scene.add(labelMesh)

        // setGUISettings()
        onResize()
        setInterval(onColorChange, 3000)
        renderer.setAnimationLoop(onAnimLoop)
        document.body.addEventListener('mousemove', onMouseMove)
        window.addEventListener('resize', onResize)

        WebFont.load({
            custom: {
                families: ['GoshaSans']
            },
            fontactive: onFontLoaded,
            fontinactive: onFontLoadError,
        })

        function onAnimLoop() {
            const dt = clock.getDelta()

            if (OPTIONS.animateColor) {
                PERSIST_COLOR[0] += (TARGET_PERSIST_COLOR[0] - PERSIST_COLOR[0]) * dt
                PERSIST_COLOR[1] += (TARGET_PERSIST_COLOR[1] - PERSIST_COLOR[1]) * dt
                PERSIST_COLOR[2] += (TARGET_PERSIST_COLOR[2] - PERSIST_COLOR[2]) * dt
            }

            {
                const mouseSpeed = dt * 5
                mousePos[0] += (targetMousePos[0] - mousePos[0]) * mouseSpeed
                mousePos[1] += (targetMousePos[1] - mousePos[1]) * mouseSpeed

                fullscreenQuadMaterial.uniforms.mousePos.value.x = mousePos[0]
                fullscreenQuadMaterial.uniforms.mousePos.value.y = mousePos[1]
            }

            fullscreenQuadMaterial.uniforms.sampler.value = fluidRenderTarget1.texture
            fullscreenQuadMaterial.uniforms.time.value = clock.getElapsedTime()

            renderer.autoClearColor = false

            renderer.setRenderTarget(fluidRenderTarget0)
            renderer.clearColor()
            renderer.render(fluidScene, orthoCamera)
            labelMesh.material.uniforms.color.value.set(...PERSIST_COLOR)
            renderer.render(scene, orthoCamera)

            renderer.setRenderTarget(null)
            labelMesh.material.uniforms.color.value.set(...PERSIST_COLOR)
            renderer.render(fluidScene, orthoCamera)
            renderer.render(scene, orthoCamera)

            const temp = fluidRenderTarget0
            fluidRenderTarget0 = fluidRenderTarget1
            fluidRenderTarget1 = temp
        }

        function onColorChange() {
            TARGET_PERSIST_COLOR[0] = Math.random()
            TARGET_PERSIST_COLOR[1] = Math.random()
            TARGET_PERSIST_COLOR[2] = Math.random()
        }

        function drawText({
            text = OPTIONS.text,
            fontFamily = OPTIONS.fontFamily,
            horizontalPadding = 0.75,
        } = {}) {
            const idealCanvasSize = 2048
            const maxTextureSize = Math.min(
                renderer.capabilities.maxTextureSize,
                idealCanvasSize,
            )
            texCanvas.width = maxTextureSize
            texCanvas.height = maxTextureSize

            texCtx.fillStyle = '#fff'
            texCtx.strokeStyle = '#fff'
            texCtx.lineWidth = 1
            texCtx.textAlign = 'center'
            texCtx.textBaseline = 'middle'
            const referenceFontSize = 250
            texCtx.font = `${referenceFontSize}px ${fontFamily}`
            const textWidth = texCtx.measureText(text).width
            const deltaWidth = (texCanvas.width * horizontalPadding) / textWidth
            const fontSise = referenceFontSize * deltaWidth
            texCtx.font = `${700}px ${fontFamily}`
            texCtx.fillText(text, texCanvas.width / 2, texCanvas.height / 2)

            labelMaterial.uniforms.sampler.value = new THREE.CanvasTexture(texCanvas)
        }

        function onMouseMove(e) {
            const x = (e.pageX / innerWidth) * 2 - 1
            const y = (1 - e.pageY / innerHeight) * 2 - 1
            targetMousePos[0] = x
            targetMousePos[1] = y
        }

        function onResize(resizeCamera = true, resizeFramebuffers = true) {
            renderer.setSize(innerWidth, innerHeight)
            renderer.setPixelRatio(devicePixelRatio || 1)

            const aspect = innerWidth / innerHeight

            fullscreenQuadMaterial.uniforms.aspect.value = aspect

            if (resizeCamera) {
                orthoCamera.left = -innerWidth / 2
                orthoCamera.right = innerWidth / 2
                orthoCamera.top = innerHeight / 2
                orthoCamera.bottom = -innerHeight / 2
                orthoCamera.aspect = aspect
                orthoCamera.updateProjectionMatrix()
            }

            if (resizeFramebuffers) {
                fluidRenderTarget0.setSize(
                    renderer.domElement.clientWidth,
                    renderer.domElement.clientHeight,
                )
                fluidRenderTarget1.setSize(
                    renderer.domElement.clientWidth,
                    renderer.domElement.clientHeight,
                )
            }
        }

        function onFontLoaded(familyName, fvd) {
            fontFamilies.push(familyName)

            if (familyName === DEFAULT_FONT_FAMILY) {
                drawText()
            }
        }

        function onFontLoadError(familyName, fvd) {
            console.error(`Could not load ${familyName} ${fvd}`)
        }
    }


}
notFoundWebgl()


// Page transitions animations
function transitionIn() {
    var tl = gsap.timeline();
    tl.to(".loadingScreen", {
        duration: .4,
        autoAlpha: 1,
        ease: "Expo.easeInOut",
    });
}
function transitionOut() {
    var tl = gsap.timeline();
    tl.to(".loadingScreen", {
        duration: .4,
        autoAlpha: 0,
        delay: 1,
        ease: "Expo.easeInOut",
    });
}

// Transition & Page  Animation 
const VideoLoadAnimation = () => {
    if ($('.fadeInVideo').length > 0) {
        if (window.innerWidth < 1030) {
            var tl = gsap.timeline();
            tl.from(".fadeInVideo", { duration: 2.2, opacity: 1, x: 0, y: 400, delay: .2, ease: "Expo.easeInOut" });
            // tl.from(".fadeInContent", { duration: 1, opacity: 0, delay: 1, ease: "Expo.easeInOut" });
        } else {
            var tl = gsap.timeline();
            tl.from(".fadeInVideo", { duration: 2.2, opacity: 1, x: 400, delay: .2, ease: "Expo.easeInOut" });
            // tl.from(".fadeInContent", { duration: 1, opacity: 0, delay: 1, ease: "Expo.easeInOut" });
        }

        setTimeout(() => { $("#workDetails--more").addClass("show") }, 2000);
    }
}



const contentAnimation = () => {
    if (window.innerWidth < 1030) {
        var tl = gsap.timeline();
        tl.from(".contentIn", { duration: 2.2, opacity: 1, y: 400, delay: .5, ease: "Expo.easeInOut" });
    } else {
        var tl = gsap.timeline();
        tl.from(".contentIn", { duration: 2.2, opacity: 1, x: 400, delay: .5, ease: "Expo.easeInOut" });
    }
}

const detailsMobileTrans = () => {
    if (window.innerWidth < 1030 && $('.mcontentIn').length > 0) {
        var tl = gsap.timeline();
        tl.from(".mcontentIn", { duration: 2.2, opacity: 1, y: 400, delay: .2, ease: "Expo.easeInOut" });
    }
}
detailsMobileTrans()
const mobileLoaderIn = () => {
    if (window.innerWidth < 1030) {
        var tl = gsap.to('.mobileLoader', {
            autoAlpha: 1,
            duration: .3
        });
    }
}
const mobileLoaderOut = () => {
    if (window.innerWidth < 1030) {
        var tl = gsap.to('.mobileLoader', {
            autoAlpha: 0,
            duration: .3
        });
    }
}



require('scroll-restoration-polyfill');
if ('scrollRestoration' in history) {
    // Back off, browser, I got this...
    history.scrollRestoration = 'manual';
}


function mobileSetOffsetHeight() {
    let secChecked = 0
    let clientNameInt = setInterval(() => {
        if (window.innerWidth < 1030) {
            let headerOffset = document.querySelectorAll(".new__menuLink.client__name.chars:not(.hide)")[1];

            if (headerOffset) {
                headerOffset = headerOffset.offsetHeight

                document.getElementById("promptParent").style.padding = `${Math.max((headerOffset + 40), 130)
                    }px 20px`;

                clearInterval(clientNameInt)
            }
        } else { clearInterval(clientNameInt) }

        if (secChecked > 10) { clearInterval(clientNameInt) }
        secChecked += 1
    }, 500);
}
mobileSetOffsetHeight();

barba.hooks.enter((data) => {
    Splitting(),
        [...document.querySelectorAll('a , button')].forEach(link => {
            link.addEventListener('click', () => cursor.active());
            link.addEventListener('mouseenter', () => cursor.enter());
            link.addEventListener('mouseleave', () => cursor.leave());
        });

    if (window.innerWidth > 1030) {
        let scrBar = document.getElementsByClassName("c-scrollbar_thumb")[0]
        scrBar.addEventListener('click', () => cursor.active());
        scrBar.addEventListener('mouseenter', () => cursor.enter());
        scrBar.addEventListener('mouseleave', () => cursor.leave());
    }
});

$('.tr a').click(function (e) { this.classList.add('active'); });

barba.init({
    sync: true,
    debug: true,

    views: [{
        namespace: 'home',
        once(data) {
            homeScrPrompt()
        },
        beforeEnter(data) {
            if (!$('body').hasClass('hc_loaded')) {
                homeContent()
            }
            if ($('.p_link').hasClass('active')) {
                $('.tr a').removeClass('active')
            }
            if ($('.p_link').hasClass('active')) {
                $('.bl a').removeClass('active')
            }
            let introLink = document.querySelector('.intro_us_lisk')

            introLink.addEventListener('mouseenter', function () {
                $('.bl .p_link').addClass('active')
            })
            introLink.addEventListener('mouseleave', function () {
                $('.bl .p_link').removeClass('active')
            })
            var ivid = document.getElementById("i_video");
            ivid.play()
            titleHanlder()
            drawImageHandler();
            if (!$('body').hasClass('nav-loaded')) {
                setTimeout(() => {
                    navData()
                }, 500);
            }
            setTimeout(() => {
                workHoverHanlder()
                navLinkHover()
            }, 600);
            detailsNavHandler()
            homeScrPrompt()
            scrPrompt.classList.remove("master-off")

        },
        enter(data) {

        },
        beforeLeave(data) {
            gsap.to(scrPrompt, {opacity: 0, duration: .8})
            document.removeEventListener("scroll", scrPromptMouse)
            document.addEventListener("mousemove",scrPromptMouse)
            scrPrompt.classList.add("master-off")
        }
    }, {
        namespace: 'work',
        beforeEnter(data) {
            workContent()
            titleHanlder()
            if (!$('body').hasClass('nav-loaded')) {
                setTimeout(() => {
                    navData()
                }, 500);
            }
            setTimeout(() => {
                workHoverHanlder()
            }, 600);
            detailsNavHandler()
            // $('.tr a').addClass('active')
            if (!$('.p_link').hasClass('active')) {
                $('.tr a').addClass('active')
            }

        },
    },
    {
        namespace: 'about',
        beforeEnter(data) {
            aboutContent();
            titleHanlder()
            aboutUswebGlHandler()
            drawImageHandler()
            detailsNavHandler()
            contactHandler()
            formHandler()
            dateHanler()
            var usmobilehead = document.getElementById("mobile_head");
            usmobilehead.muted = true;
            usmobilehead.play()
            if (!$('.p_link').hasClass('active')) {
                $('.bl a').addClass('active')
            }
        },
        enter(data) {
            var vid = document.getElementById("us_video");
            vid.muted = true;
            vid.play()
        },
        beforeLeave(data) {
            resetColor()

            document.removeEventListener("mousemove",calcTarget)
            cancelAnimationFrame(tick)
        }
    },
    {
        namespace: 'details',
        beforeEnter(data) {
            workSingleContent();
            detailsNavHandler()
            navResetHandler()
            titleHanlder()

            let videoWrapper = document.querySelector('.video__banner')
            videoWrapper.addEventListener('mouseenter', () => { cursor.enter() })
            videoWrapper.addEventListener('mouseleave', () => { cursor.leave() })
            if (!$('body').hasClass('videoModeOn')) {
                detailsVideoHandler()
            }
            $('.tr a').addClass('active')
            scrPrompt.classList.add("master-off")
            // do something before entering the `contact` namespace

        },
        enter() {
            VideoLoadAnimation()
            mobileSetOffsetHeight();
        },
        afterEnter() {
            projectHome();
            setTimeout(() => {
                gsap.to(("#scrPrompt"), { display: "block" })
            }, 2000);
        },
        beforeLeave() {
            navResetHandler2()
            homeBtnRemoveEvents()
            gsap.to(("#scrPrompt"), { display: "none" })
        },
        afterLeave() {
            cursor.leave()
        }
    }],
    transitions: [
        {
            leave() {
                const done = this.async();
                transitionIn()
                navResetHandler()
                if ($('body').hasClass('hc_loaded')) {
                    $('body').removeClass('hc_loaded')
                }
                if ($('body').hasClass('intro_loaded')) {
                    $('body').removeClass('intro_loaded')
                }
                if ($('.notFound').length > 0) {
                    $('.cursor').show()
                    $('.cursor2').removeClass('show')
                }
                _cursorAnimation.play()
                mobileLoaderIn()
                setTimeout(() => {
                    done()
                }, 2000);
            },
            afterLeave({ next }) {
                lscroll.destroy();
            },
            beforeEnter() {
                Splitting()
            },
            once() {

            },
            enter() {
                lscroll.init()
                lscroll.scrollTo(0)
                _infiniteProject()

                if ($('.aboutUs').length > 0) {
                    setTimeout(function () {
                        lscroll.update();
                        transitionOut()
                         Promise.all([preloadImages('img')]).then(() => {
                            contentAnimation()
                        });
                    }, 1000);
                } else {
                    lscroll.update();
                    transitionOut()
                    Promise.all([preloadImages('img')]).then(() => {
                        contentAnimation()
                    });
                    detailsMobileTrans()
                }

                mobileLoaderOut()
                setTimeout(() => {
                    _cursorAnimation.pause()
                }, 2000);

            },
            after() {
               
                
            },
        },
    ],
});